class CustomHighcharts extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      const ELM_charts = document.querySelectorAll('[data-chart]');
      ELM_charts.forEach(elm => {
        const chartData = elm.getAttribute('data-chart-data') || null;
        if (chartData) {
          const fData = JSON.parse(chartData);
          const typeChart = fData.type;
          if (fData) {
            const formatJson = {
              ...fData,
              id: elm.getAttribute('id')
            };
            formatJson && this.initChart(typeChart, formatJson);
          }
        }
      });
    });
  }

  initChart(type, props) {
    switch (type) {
      case 'pie':
        this.initPieChart({...props});
        break;
      case 'bar':
      case 'column':
        this.initBarChart({...props});
        break;
      case 'custom-bar':
        this.initCustomBarChart({...props});
        break;
      default:
        this.initMapChart({...props});
        break;
    }
  }

  initPieChart(props) {
    const { id, colors, categories, data } = props;
    Highcharts.chart(id, {
      chart: {
        height: 300,
        backgroundColor: "transparent",
        type: 'pie'
      },
      legend: {
        itemStyle: {
          color: '#aaa',
          fontWeight: '300',
          fontSize: '11px'
        },
        itemHoverStyle: {
          color: '#fff'
        }
      },
      colors,
      title: {
        text: ''
      },
      xAxis: {
        categories,
        labels: {
          style: {
            color: '#aaa'
          }
        },
        tickLength: 0
      },
      yAxis: {
        gridLineWidth: 0,
        title: {
          enabled: false
        },
        stackLabels: {
          enabled: false
        },
        labels: {
          style: {
            color: '#aaa'
          }
        },
      },
      series: [
        {
          data
        }
      ],
      credits: {
        enabled: false
      },
      tooltip: {
        formatter: function() {
          let val = '';
          if (this.x == undefined) val = '<b>' + this.point.name + '</b>: ';
          return  val + '' + this.y + '%';
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
        series: {
          stacking: 'normal',
          borderWidth: 0,
        },
      }
    })
  }

  initBarChart(props) {
    const { type, id, colors, categories, data } = props;
    Highcharts.chart(id, {
      chart: {
        height: 300,
        backgroundColor: "transparent",
        type
      },
      legend: {
        enabled: false
      },
      colors,
      title: {
        text: ''
      },
      xAxis: {
        categories,
        labels: {
          style: {
            color: '#aaa'
          }
        },
        tickLength: 0
      },
      yAxis: {
        gridLineWidth: 0,
        title: {
          enabled: false
        },
        stackLabels: {
          enabled: false
        },
        labels: {
          style: {
            color: '#aaa'
          }
        },
      },
      series: [
        {
          data
        }
      ],
      credits: {
        enabled: false
      },
      tooltip: {
        formatter: function() {
          let val = '';
          if (this.x == undefined) val = '<b>' + this.point.name + '</b>: ';
          return  val + '' + this.y + '';
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
        series: {
          stacking: 'normal',
          borderWidth: 0,
        },
      }
    });
  }

  initCustomBarChart(props) {
    const { id, colors, format, series } = props;
    Highcharts.chart(id, {
      chart: {
        height: 300,
        backgroundColor: "transparent",
        type: 'bar'
      },
      legend: {
        enabled: false
      },
      colors,
      title: {
        text: ''
      },
      xAxis: {
        labels: {
          enabled: false
        },
        lineWidth: 0,
        tickLength: 0
      },
      yAxis: {
        min: 0,
        max: 120000,
        lineWidth: 1,
        gridLineWidth: 1,
        title: {
          enabled: false
        },
        stackLabels: {
          enabled: false
        },
        labels: {
          style: {
            color: '#aaa'
          }
        },
      },
      series,
      credits: {
        enabled: false
      },
      tooltip: {
        formatter: function() {
          return format;
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
        series: {
          stacking: 'normal',
          borderWidth: 0,
        },
      }
    });
  }

  initMapChart(props) {
    const { id, colors, categories, data } = props;
    Highcharts.mapChart(id, {
      chart: {
        backgroundColor: "transparent",
        height: 300,
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      legend: {
        enabled: false
      },
      colorAxis: {
        min: 0,
        minColor: '#13e2f9',
        maxColor: '#047b88',
      },
      series: [{
        data,
        mapData: Highcharts.maps['countries/au/au-all'],
        joinBy: 'hasc',
        borderWidth: 0,
      }],
      tooltip: {
        formatter: function() {
          let val = '';
          if (this.x == undefined) val = '<b>' + this.point.name + '</b>: ';
          return  val + '' + this.point.value + '%';
        }
      }
    });
  }

  initEmploymentStateChart() {
    Highcharts.mapChart('employment-state', {
      chart: {
        backgroundColor: "transparent",
        height: 300,
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      legend: {
        enabled: false
      },
      colorAxis: {
        min: 0,
        minColor: '#13e2f9',
        maxColor: '#047b88',
      },
      series: [{
        data: [
          {
            hasc: "AU.NS",
            value: 33.3
          },

          {
            hasc: "AU.VI",
            value: 21.9
          },

          {
            hasc: "AU.QL",
            value: 19.8
          },

          {
            hasc: "AU.SA",
            value: 5.1
          },

          {
            hasc: "AU.WA",
            value: 13.0
          },

          {
            hasc: "AU.TS",
            value: 2.2
          },

          {
            hasc: "AU.NT",
            value: 1.6
          },

          {
            hasc: "AU.CT",
            value: 3.1
          }
        ],
        mapData: Highcharts.maps['countries/au/au-all'],
        joinBy: 'hasc',
        borderWidth: 0,
      }],
      tooltip: {
        formatter: function() {
          let val = '';
          if (this.x == undefined) val = '<b>' + this.point.name + '</b>: ';
          return  val + '' + this.point.value + '%';
        }
      }
    });
  }
}

customElements.define('custom-highcharts', CustomHighcharts);
